// extracted by mini-css-extract-plugin
export default {"container":"vVFihk","content":"kCk7Do","sidePanel":"pLRkhT","withSidePanel":"QHykhV"};